import { connect } from 'react-redux'
import Works from './works'
import { getAssessmentFile } from '../../../../../stores/assessment-file/assessment-file.selectors'
import {
  getWorksList,
  getWorksCount
} from '../../../../../stores/works/works.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { match, me }) => {
  const assessmentFile = getAssessmentFile(state)
  const works = getWorksList(state)
  return {
    id: assessmentFile.id,
    works,
    count: getWorksCount(state)
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(Works)
)
